export const stat = [
    {
        green: '№1 в России',
        text: 'по средней скорости доступа в интернет — 93 мбит/с',
    },
    {
        green: '1258',
        text: 'населенных пунктов подключено',
    },
    {
        green: '13,4 млн',
        text: 'домохозяйств в сети',
    },
];

export const story = [
    {
        year: '2022 — новое начало',
        text: 'Дом.ру проводит ребрендинг. Теперь мы — проводник в осознанный цифровой мир. ' +
            'Совместно с «Ростехом» завершается сделка по приобретению «АКАДО Холдинг». ' +
            'Масштабные инвестиции стали частью стратегии компании по развитию на рынке Москвы и Московской области.',
    },
    {
        year: '2021 — новые продукты и пакетные предложения',
        text: 'Вышла новая линейка пакетных тарифов «Засмотрись», с подпиской на популярные онлайн-кинотеатры, ' +
            'скоростным интернетом, более сотней телеканалов и новой ТВ-приставкой с голосовым поиском на выгодных ' +
            'условиях, позволяющих клиентам сэкономить более 40%. Можно выбрать пакет с Кинопоиском и Яндекс.Плюс ' +
            'или с онлайн-кинотеатром IVI. Онлайн-кинотеатры Start и Amediateka входят в оба пакета. ' +
            'Киберспортсмены оценили новые скорости игровых тарифов Дом.ру до 600 Мбит/с на первом открытом чемпионате по ' +
            'CounterStrike среди 38 городов Российской Федерации. Призовой фонд кибертурнира Дом.ру составил 500 000 рублей. ' +
            'С нашей поддержкой в Перми провели первый Международный кинофестиваль «Форма жизни» («SHAPE OF LIFE»), ' +
            'посвященный вопросам сохранения окружающей среды и всех форм жизни, представленных на планете. Дом.ру ' +
            'выступил партнером Двадцатых молодежных Дельфийских игр России, оказав масштабную телеком-поддержку гостям, ' +
            'участникам и организаторам.',
    },
    {
        year: '2020 — бесконтактное развитие',
        text: 'Дом.ру запустил сервис дистанционной видео поддержки клиентов и внедрил бесконтактное подключение телеком-услуг.' +
            ' «Дом.ру пригласил поклонников компьютерных игр к участию в турнире #ИграемДома, ' +
            'организованном Федерацией компьютерного спорта России. В рамках партнерства «Дом.ру ' +
            'показал трансляцию финала игр по Dota 2 и провел прямой эфир с киберспортивным ' +
            'талантом студии аналитики RuHub Ярославом NS Кузнецовым. ' +
            'Компания поддержала Ночь музеев, пригласив клиентов на авторские онлайн-экскурсии по городам и музеям, ' +
            'мастер-классы по живописи.',
    },
    {
        year: '2019 — год рождения приставки Movix ',
        text: 'Представлена первая «умная» цифровая ТВ-приставка на базе Android — Movix Pro. Дом.ру ' +
            'первым среди операторов платного ТВ в России запускает собственное приложение для ' +
            'очков виртуальной реальности. На виртуальном экране доступно 20 телеканалов. Проведен второй ' +
            'открытый собственный чемпионат России по Dota 2 с призовым фондом 1 млн рублей.',
    },
    {
        year: '2018 — переходим на новый уровень',
        text: 'Дом.ру запускает мультиплатформенное ТВ «Дом.ру Movix, которое можно смотреть с ' +
            'экрана телевизора через приложение для Smart TV, с мобильных устройств или на сайте movix.ru. ' +
            'Запускается новая линейка высокоскоростных Wi-Fi роутеров, поддерживающих скорость от 100 Мбит/c и ' +
            'работающих в 2 диапазонах частот. Проект «Умные домофоны» запущен в 25 городах. Монтированная емкость сети Дом.ру ' +
            'увеличена на 465 тысяч квартир.',
    },
    {
        year: '2017 — поддержка Чемпионата мира',
        text: 'В преддверии Чемпионата мира по футболу и Кубка Конфедераций в Санкт-Петербурге разворачивается ' +
            'многофункциональная инфраструктура, включающая общедоступную Wi-Fi сеть, систему видеомониторинга на ' +
            'улицах города и оповещения на спортивных объектах. Запущены пилотные проекты в нефтедобывающей, ' +
            'сельскохозяйственной и энергетической отраслях. Завершаются сделки по приобретению крупных федеральных и ' +
            'региональных операторов ООО «Новотелеком», АО «ТКС-Нева» и АО «Акадо-Екатеринбург», ООО «Коламбия Телеком».',
    },
    {
        year: '2016 — очень быстрый рост',
        text: 'Дом.ру признан самым быстрорастущим оператором связи в России. Международное рейтинговое агентство ' +
            'Standard and Poor’s присвоило холдингу рейтинг B+, а Moody’s улучшили прогноз по текущему ' +
            'рейтингу B2 на позитивный. В Москве запущена городская Wi-Fi сеть из 1100 точек доступа внутри Садового кольца.',
    },
    {
        year: '2015 — год запуска Дом.ру TV Mini',
        text: 'Корейские HUMAX и KAON, французская Ekinops — сотрудничают с Дом.ру. Запуск серийного производства ' +
            'ТВ-приставки «Дом.ру TV Mini» в Перми. Расширение возможностей сервиса мультискрин «Дом.ру TV to Go» ' +
            'позволило смотреть ТВ-программы и шоу с экранов гаджетов в любой точке России, где есть беспроводной ' +
            'доступ в интернет.',
    },
    {
        year: '2014 — новые умные устройства',
        text: 'Представлены 2 новых устройства для подключения к цифровому ТВ. Инновационная ТВ-приставка «Дом.ру TV» с ' +
            'сервисами, как multiscreen, catch-up, видеотека, многоуровневый поиск контента, мобильный пульт. ' +
            'Второе устройство «Дом.ру TV Mini» можно подключить к любому телевизору и устаревшим моделям. 163 телеканала, ' +
            'из них 56 каналов в HD-формате, что является максимумом на российском рынке.',
    },
    {
        year: '2013 — самые-самые во многом',
        text: 'Укрепили позиции по самому большому количеству HD-каналов в России, увеличив их число с 35 до 50. ' +
            'Еще более 100 каналов работает в стандартном цифровом формате. Wi-Fi сеть провайдера интернета ' +
            'Дом.ру — самая большая в России: 56 городов, 5 000 бесплатных точек.',
    },
    {
        year: '2012 — выходим на b2b рынок',
        text: 'Запуск Дом.ру Бизнес для корпоративных клиентов. Запуск нового формата HD-телевидения ' +
            '«Дом.ру TV» в 19 городах. Ускорение до 100 Мбит/c. В ноябре Дом.ру подключил 5-миллионного абонента.',
    },
    {
        year: '2011 — год стартапа',
        text: 'Запущено 15 start up-проектов: в Уфе, Кургане, Туле, Ульяновске, Магнитогорске, Дзержинске, Сызрани, ' +
            'Рязани, Иркутске, Томске, Брянске, Чебоксарах, Твери, Курске и Ростове-на-Дону.',
    },
    {
        year: '2010 — начало пути',
        text: 'Начало реализации лидерской стратегии Дом.ру.',
    },
];

export const description = [
    {
        icon: '',
        title: 'Подарки и скидки',
        text:'Бесплатно и каждый месяц новые. ТВ-каналы, каталоги с фильмами и сериалами, антивирусы, бонусы скорости и многое другое.',
    },
    {
        icon: '',
        title: 'Простое управление услугами',
        text:'Решайте вопросы в личном кабинете и мобильном приложении. Легко меняйте тариф, подключайте или приостанавливайте услуги.',
        link:'',
    },
    {
        icon: '',
        title: 'Круглосуточную техподдержку',
        text:'Ответим в любое время и поможем решить все вопросы. Общаемся в чате на сайте, в мобильном приложении и по телефону.',
        link:'',
    },
    {
        icon: '',
        title: 'Надежную интернет-сеть',
        text:'Используем надежную технологию FTTB и мониторим сеть 24/7. Интернет, который не подведет вас.',
        link:'',
    },
];

export const business = [
    {
        icon: '',
        title: 'Интернет в квартиру и частный дом',
        text:'Одинаково мощный на всех устройствах. Смотрите фильмы онлайн на ноутбуке, скачивайте файлы и играйте без перебоев.',
        link:{
            text: 'Посмотреть тарифы интернета',
            href: '/internet',
        },
    },
    {
        icon: '',
        title: 'Засмотрись всей семьей',
        text:'Кино и сериалы из топовых онлайн-кинотеатров, мощный интернет и ТВ-каналы на любой вкус в высоком качестве.',
        link: {
            text: 'Узнать больше про цифровое ТВ',
            href: '/movix-new',
        },
    },
    {
        icon: '',
        title: 'Все, что вам важно — под присмотром',
        text:'Узнавайте как дела дома прямо с экрана собственного смартфона. Смотрите телеархив и получайте уведомления от камер.',
        link:{
            text: 'Узнать больше про мобильное ТВ',
            href: '/domru-tv/mobile',
        },
    },
];
